import React from 'react';
import * as S from '../BreadcrumbDetails/BreadcrumbDetailsLoader.styles';

const BreadcrumbsDetailsLoader = () => (
  <S.BreadcrumbDetailsLoaderWrapDiv>
    <S.BreadcrumbHotelDetailsWrapDiv>
      <S.HotelInfoDiv></S.HotelInfoDiv>
      <S.HotelNameWrapDiv>
        <S.HotelNameDiv></S.HotelNameDiv>
        <S.HotelToolTip></S.HotelToolTip>
      </S.HotelNameWrapDiv>
      <S.HotelAddressDiv></S.HotelAddressDiv>
    </S.BreadcrumbHotelDetailsWrapDiv>

    <S.BreadcrumbReviewDetailsWrapDiv>
      <S.HotelReviewDiv></S.HotelReviewDiv>
      <S.HotelRakingDiv></S.HotelRakingDiv>
    </S.BreadcrumbReviewDetailsWrapDiv>
  </S.BreadcrumbDetailsLoaderWrapDiv>
);

export default BreadcrumbsDetailsLoader;
